import React from "react";
import {connect} from "react-redux";
import {FormattedMessage} from "react-intl";

import {
  setAllFinanceOptionsPopupVisible,
} from "../../actions/priceWorksheetActions";
import {DISCOUNT_SECTION_TYPES} from "./discounstInterface";
import WithOverlay from "../popups/withOverlayHoc";

const DiscountAllFinanceOptionsPopup = (props) => {

  const {allFinanceOptionsPopupVisible, discountSections, setAllFinanceOptionsPopupVisible} = props;
  if (!allFinanceOptionsPopupVisible) {
    return null
  }

  const financeSection = discountSections.find(sec => sec.type === DISCOUNT_SECTION_TYPES.finance);
  if (!financeSection) {
    return null;
  }

  const selectItemHeight = 33;
  const maxItems = 10;
  let styles = {
    height: maxItems && (financeSection.discounts.length > maxItems)
      ? (maxItems * selectItemHeight) + 56 + "px"
      : (financeSection.discounts.length * selectItemHeight) + 56 + "px"
  }

  const closePopup = () => setAllFinanceOptionsPopupVisible(false);

  return (
    <WithOverlay className="overlay--confirm flex flex--center" onClick={closePopup} popupClassName="dr-dropdown">
      {(hideOverlay) => (
        <div className={"dr-container dr-container--opened dr-container--full-width dr-container--280"}>
          <div className="dr-dropdown" style={styles}>
            <div className="dr-dropdown__list-item dr-dropdown__title bold flex flex--top flex--start nowrap">
              <FormattedMessage id={"shoppingCart.discounts.financingRates"}/>
            </div>
            <button className="ui-close ui-close--gray dr-dropdown__close" onClick={() => hideOverlay(closePopup)}/>
            <ul className={"dr-dropdown__list fix-ul"
              + (maxItems && (financeSection.discounts.length > maxItems) ? " dr-dropdown__list--scroll" : "")}>
              {financeSection.discounts.map((discount) => {
                return (
                  <li className="dr-dropdown__list-item" key={discount.uuId || discount.id}>
                    <div className={" flex flex--between dr-dropdown__list-item-text dr-dropdown__list-item-text--no-hover"}>
                      <span>
                        {discount.financePercentage}% <span className={"text-lowercase"}><FormattedMessage
                        id={"shoppingCart.discounts.for"}/></span> {discount.financeMonths} <FormattedMessage id={"shoppingCart.discounts.months"}/>
                      </span>
                      <span>{discount.financeSalesPercentage ? discount.financeSalesPercentage + "%" : null}</span>
                    </div>
                  </li>
                )
              })}
            </ul>
          </div>
        </div>
      )}
    </WithOverlay>
  )
}

const mapStateToProps = (store) => {
  const {allFinanceOptionsPopupVisible, discountSections} = store.priceWorksheetState;
  return {
    allFinanceOptionsPopupVisible,
    discountSections,
  };
};

const mapDispatchToProps = {
  setAllFinanceOptionsPopupVisible,
};

export default connect(mapStateToProps, mapDispatchToProps)(DiscountAllFinanceOptionsPopup);
